/** The "agreement isn’t set up yet" empty state (H §6.2): no agreement, or no current terms. */
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function NotPricedState() {
  const { t } = useTranslation();
  return <Alert severity="info">{t('tenant.notPriced')}</Alert>;
}
